/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Circle, Path, Polyline } from 'react-native-svg';

import { IconProps } from '../lib';

function RedditLogo(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Circle
        cx={188}
        cy={32.00002}
        r={16}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M161.026,176.00058a72.17425,72.17425,0,0,1-66.05159.0002"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Polyline
        points="128 72 136 24 172.185 29.567"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Path
        d="M59.408,89.87843C77.71654,78.7483,101.71994,72,128,72s50.28346,6.7483,68.592,17.87843l-.00129.00213a24.002,24.002,0,1,1,31.61564,34.788l.002-.00083A51.61606,51.61606,0,0,1,232,144c0,39.7645-46.56239,72-104,72S24,183.7645,24,144a51.61624,51.61624,0,0,1,3.79162-19.3323l.00206.00082a24.00228,24.00228,0,1,1,31.61564-34.788Z"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={8}
      />
      <Circle cx={88} cy={132.00002} r={12} />
      <Circle cx={168} cy={132.00002} r={12} />
    </Svg>
  );
}

export default RedditLogo;
